/**
 * Which fixed box a client logo gets, from its own width/height — see
 * src/styles/clientLogos.scss for the four boxes these keys map to and
 * _tokens.scss for their actual sizes.
 */
const getClientLogoBand = (width, height) => {
  const ratio = width / height
  if (ratio >= 4) return "very-wide"
  if (ratio >= 2) return "wide"
  if (ratio >= 0.8) return "square-ish"
  return "tall"
}

export default getClientLogoBand
